import { render, staticRenderFns } from "./CartInfoModal.vue?vue&type=template&id=06aa4e0d&scoped=true"
import script from "./CartInfoModal.vue?vue&type=script&lang=ts"
export * from "./CartInfoModal.vue?vue&type=script&lang=ts"
import style0 from "./CartInfoModal.vue?vue&type=style&index=0&id=06aa4e0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aa4e0d",
  null
  
)

export default component.exports